import { LayoutThemeEnum } from '../models/layout-theme.enum';

export class SetTheme {
  static readonly type = '[Layout] Set theme';
  constructor(public theme: LayoutThemeEnum) { }
}

export class ResetLayout {
  static readonly type = '[Layout] Reset';
  constructor() { }
}
